export default __webpack_public_path__ + "static/media/logo.ca2dd019.svg";